import { useUser } from "$global-providers/user-provider";
import { gql } from "@apollo/client";
import { useInventoryFacilityLocationsQuery } from "./__generated__/use-facility-locations.gql";

gql`
  query inventoryFacilityLocations($facilityId: String!) {
    facilityLocations(input: { clinicUuids: [$facilityId], active: true }) {
      _id
      name
    }
  }
`;

export function useFacilityLocations() {
  const { facilityId } = useUser();

  const { data, loading, error } = useInventoryFacilityLocationsQuery({
    variables: {
      facilityId,
    },
    skip: !facilityId,
  });

  const facilityLocations = data?.facilityLocations;

  return { data: facilityLocations, loading, error };
}

export function useFacilityLocationName(
  locationId?: string,
): string | undefined {
  const { facilityId } = useUser();

  const { data } = useInventoryFacilityLocationsQuery({
    variables: {
      facilityId,
    },
    skip: !facilityId,
  });

  return data?.facilityLocations.find(({ _id }) => _id === locationId)?.name;
}

export function useGetFacilityLocationName() {
  const { facilityId } = useUser();

  const { data } = useInventoryFacilityLocationsQuery({
    variables: {
      facilityId,
    },
    skip: !facilityId,
  });

  return (locationId: string) =>
    data?.facilityLocations.find(({ _id }) => _id === locationId)?.name;
}
